import { createFileRoute } from '@tanstack/react-router';

import { PortalInvoicesPage } from '@/modules/portal/pages/PortalInvoicesPage';

export const Route = createFileRoute('/account/invoices/')({
  component: PortalInvoicesPage,
});
